var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("暂无站内信 "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/gocat')}}},[_vm._v("回到GO车惠")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }